import { Box, Divider, Typography } from "@mui/material";

export default function ProjectSettingMember() {
    return (
        <Box>
            <Typography variant="h5" gutterBottom>
                Members
            </Typography>

            <Divider />

            <div>NEXT FEATURE</div>
        </Box>
    );
}
